import _                            from 'underscore';
import React, { CSSProperties, FC } from 'react';
import { Form }                     from 'semantic-ui-react';
import { FormPointerErrorMessage }  from './FormPointerErrorMessage';

interface FieldWrapperProps {
	showErrors?: boolean,
	includeErrorMessage?: boolean,
	errorContainerStyles?: CSSProperties,
	meta?: any,
	field?: any,

	[ additionalProps: string ]: any
}

const defaultProps: FieldWrapperProps = {
	errorContainerStyles: {}
}

const FieldWrapper: FC<FieldWrapperProps> = ( _props ) => {

	let {
		    showErrors,
		    includeErrorMessage,
		    errorContainerStyles,
		    meta,
		    field,
		    ...props
	    } = _props;

	return (
		<Form.Field error={ showErrors && includeErrorMessage } className={ 'position--relative' }>

			{ props.children }

			{ showErrors && includeErrorMessage && <FormPointerErrorMessage { ...{ ...meta, ...field } } style={ errorContainerStyles ?? null }/> }

		</Form.Field>
	)
};

FieldWrapper.defaultProps = defaultProps;

export { FieldWrapper }
